import { db } from "@/firebase/firebaseConfig.js";
import AuthService from "@/services/authService.js";

class AisService {

  getStaticInfo(vesselId) {
    return new Promise((resolve, reject) => {
      db.collection("vessel_info")
        .doc(vesselId)
        .get()
        .then(function (doc) {
          if (doc.exists) {
            resolve(doc.data());
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  async getDynamicAisInfo(vesselId) {
    const collectionName = await AuthService.getVesselPositionCollectionName();
    return new Promise((resolve, reject) => {
      db.collection(collectionName)
        .doc(vesselId)
        .get()
        .then(function (doc) {
          if (doc.exists) {
            resolve(doc.data());
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

}

export default new AisService();
